"use client";

import { useEffect } from "react";

/* Registra il service worker che rende il sito installabile come app (PWA).
   Non disegna niente. Il service worker (public/sw.js) non mette nulla in
   cache: serve solo all'installazione e al messaggio "senza connessione". */
export function RegistraApp() {
  useEffect(() => {
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);
  return null;
}
